<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a>
  <span class="m-r-4">/ </span>
  <a class="m-r-4" routerLink="/master-data/repair-mode">Repair Mode</a>
  <span>/ {{ isEditMode() ? 'Edit Repair Mode' : 'Add New' }}</span>
</div>

<div class="m-b-12" style="display: flex; align-items: center; gap: 12px">
  <h3>{{ isEditMode() ? 'Edit Repair Mode' : 'Add New' }}</h3>
  @if (isEditMode()) {
    <div style="display: flex; flex-grow: 1; justify-content: end; gap: 8px">
      <mc-button
        fit="small"
        variant="outlined"
        icon="arrow-anti-clockwise-clock"
        (click)="onAuditLogClick()"
        (keydown.enter)="onAuditLogClick()"
        (keydown.space)="$event.preventDefault(); onAuditLogClick()">
        Audit log
      </mc-button>
    </div>
  }
</div>

@if (isEditMode() && repairModeData()) {
  <div class="mds-text--body-normal mds-neutral--weak__text-color m-b-12">
    Last updated on {{ repairModeData()?.updatedAt | date: 'd MMM yyyy \'at\' HH:mm:ss' }} by
    {{ repairModeData()?.updatedBy || 'User' }}
  </div>
}

<form [formGroup]="createRepairModeForm">
  @if (formSubmitErrors().length > 0) {
    <div class="error m-b-8">
      <mc-icon class="error-icon" icon="exclamation-octagon" size="20"></mc-icon>
      <div class="title">Errors</div>
      <ul>
        @for (error of formSubmitErrors(); track $index) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }
  <div class="flex-column">
    @if (formSubmitErrors().length === 0) {
      <app-error [formContainer]="createRepairModeForm"></app-error>
    }
  </div>

  <div class="pure-g">
    <div class="pure-u-1 pure-u-md-3-3 pure-u-lg-3-3 p-r-8">
      <div class="aems-card m-b-16">
        <div class="pure-g">
          <div class="pure-u-1 pure-u-md-1-2 p-r-16 m-b-16">
            <mc-input
              ngDefaultControl
              label="Mode"
              formControlName="mode"
              [attr.invalid]="isControlInErrorState(createRepairModeForm.get('mode'))"
              [disabled]="createRepairModeForm.get('mode')?.disabled ?? false"
              placeholder="Enter repair mode"
              fit="small">
              <span slot="errormessage">Mode is required</span>
            </mc-input>
          </div>
          <div class="pure-u-1 pure-u-md-1-2 p-r-16 m-b-16">
            <mc-input
              ngDefaultControl
              label="Description"
              formControlName="description"
              [attr.invalid]="isControlInErrorState(createRepairModeForm.get('description'))"
              placeholder="Enter description"
              fit="small">
              <span slot="errormessage">Description is required</span>
            </mc-input>
          </div>
          <div class="pure-u-1 p-r-16 m-b-8">
            <mc-radio-group
              ngDefaultControl
              name="isActive"
              legend="Active"
              fit="small"
              orientation="horizontal"
              formControlName="isActive"
              [attr.invalid]="isControlInErrorState(createRepairModeForm.get('isActive'))">
              <mc-radio name="isActive" value="true" label="Yes"></mc-radio>
              <mc-radio name="isActive" value="false" label="No"></mc-radio>
            </mc-radio-group>
            @if (isControlInErrorState(createRepairModeForm.get('isActive'))) {
              <div class="mds-text--caption-normal" style="color: var(--mds_brand_appearance_negative_default_text-color)">
                Active status is required
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="pure-g m-t-16">
      <div class="pure-u-1 right">
        <mc-button
          type="button"
          variant="outlined"
          appearance="neutral"
          fit="small"
          class="m-r-8"
          (click)="onCancel()"
          (keydown.enter)="onCancel()"
          (keydown.space)="$event.preventDefault(); onCancel()">
          Cancel
        </mc-button>
        <mc-button
          type="button"
          variant="filled"
          appearance="primary"
          fit="small"
          [disabled]="
            isEditMode()
              ? !createRepairModeForm.dirty || createRepairModeForm.invalid || submitLoader()
              : createRepairModeForm.invalid || submitLoader()
          "
          [loading]="submitLoader()"
          (click)="onSubmit()"
          (keydown.enter)="onSubmit()"
          (keydown.space)="$event.preventDefault(); onSubmit()">
          {{ isEditMode() ? 'Save changes' : 'Add Repair Mode' }}
        </mc-button>
      </div>
    </div>
  </div>
</form>

<!-- Cancel Confirmation Modal -->
@if (showCancelDialog()) {
  <mc-modal heading="Unsaved Changes" fit="small" dimension="small" [open]="showCancelDialog()" (closed)="keepEditing()">
    <p>Are you sure you want to cancel? All unsaved changes will be lost permanently.</p>
    <mc-button
      slot="secondaryAction"
      dialogaction="cancel"
      appearance="neutral"
      variant="filled"
      (click)="keepEditing()"
      (keydown.enter)="keepEditing()"
      (keydown.space)="$event.preventDefault(); keepEditing()">
      Keep Changes
    </mc-button>
    <mc-button
      slot="primaryAction"
      appearance="primary"
      variant="filled"
      (click)="confirmCancel()"
      (keydown.enter)="confirmCancel()"
      (keydown.space)="$event.preventDefault(); confirmCancel()">
      Discard changes
    </mc-button>
  </mc-modal>
}

<!-- Audit Log Modal -->
<mc-modal
  backdropcloseactiondisabled
  heading="Audit Log"
  fit="small"
  dimension="large"
  [open]="openAuditLog"
  (closed)="openAuditLog = false">
  @if (openAuditLog) {
    <app-master-data-audit-log
      [transactionCode]="repairModeCode"
      label="Repair Mode"
      [auditLogFetcher]="auditLogFetcher">
    </app-master-data-audit-log>
  }
</mc-modal>
